import { render } from "./SettingPanelKamokuList.vue?vue&type=template&id=c2fd402c&scoped=true&ts=true"
import script from "./SettingPanelKamokuList.vue?vue&type=script&lang=ts"
export * from "./SettingPanelKamokuList.vue?vue&type=script&lang=ts"

import "./SettingPanelKamokuList.vue?vue&type=style&index=0&id=c2fd402c&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fd402c"]])

export default __exports__